export default __webpack_public_path__ + "static/media/The 9th Estate.c6180565.png";